<template>
  <dara-modal
    v-if="showModal"
    ref="modal"
    title="Mudança de Endereço"
    :show-close-button="false"
    :full-line="true"
    @close="showModal = false">
    <template #content>
      <dara-p margin="sm">
        Você será redirecionado para o novo endereço <b>URL</b> da <b>DaraKnows</b> em {{ counter }} ...
      </dara-p>
    </template>
    <template #footer>
      <dara-button
        class="btn btn-primary"
        size="sm"
        @click="goToNewUrl()">
        Acessar
      </dara-button>
    </template>
  </dara-modal>
</template>

<script>

export default {
  name: 'DaraModalWarning',
  props: {
  },
  data() {
    return {
      showModal: true,
      counter: 10,
      url: 'https://app.daraknows.com',
    };
  },
  watch: {
    counter: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.counter--;
          }, 1000);
        } else {
          this.goToNewUrl();
        }
      },
      immediate: true,
    },
  },
  methods: {
    goToNewUrl() {
      window.location = 'https://app.daraknows.com/';
    },
  },
};
</script>
